<template>
  <div v-if="showMultipleMatch" class="match-screen">

    <!-- INSTRUCTION CHIP -->
    <div class="instruction-chip">
      {{ lang }}{{ translation.chooseImageThenDefinition }}
    </div>

    <!-- MATCH GRID -->
    <div class="match-grid">

      <!-- IMAGE COLUMN -->
      <div class="image-list">
        <ul>
          <li v-for="(image, index) in images" :key="index" @click="selectImage(index, $event)">
            <img :src="image.src" alt="image" />
          </li>
        </ul>
      </div>

      <!-- DESCRIPTION COLUMN -->
      <div class="description-list">
        <div v-for="(item, index) in shuffledItems" :key="index" class="descriptionItem"
          @click="selectDescription(item, $event)">
          {{ item.description }}
        </div>
      </div>

    </div>

    <!-- COMPLETION OVERLAY -->
    <div v-if="completed" class="over result-overlay">
      <div class="result-card">
        <div class="result-icon">🎉</div>
        <div class="result-title">{{ translation.bravo }}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    pointData: { type: Object, default: null },
  },
  data() {
    return {
      correctAnswerSound: require("../../static/sounds/correctAnswer.mp3"),
      wrongAnswerSound: require("../../static/sounds/wrongAnswer.mp3"),
      completed: false,
      selectedImage: null,
      selectedImageEl: null,
      selectedDesc: null,
      selectedDescEl: null,
      translation: {},
    };
  },
  computed: {
    showMultipleMatch() {
      if (this.$parent.showMultipleMatch == true) {
        return true;
      } else {
        return false;
      }
    },
    lang() {
      // console.log("this.$store.getters.lang", this.$store.getters.lang);
      return this.translate(this.$store.getters.lang);
    },
    shuffledItems() {
      return this.shuffleArray(this.descriptions);
    },
    currentPoint() {
      return this.pointData;
    },
    images() {
      const p = this.pointData || {};
      return [
        { src: p.itemImage1, index: 1 },
        { src: p.itemImage2, index: 2 },
        { src: p.itemImage3, index: 3 },
        { src: p.itemImage4, index: 4 },
      ];
    },
    descriptions() {
      const p = this.pointData || {};
      return [
        { description: p.description1, index: 1 },
        { description: p.description2, index: 2 },
        { description: p.description3, index: 3 },
        { description: p.description4, index: 4 },
      ];
    },
  },
  methods: {
    selectImage(index, event) {
      if (this.selectedImageEl) {
        this.selectedImageEl.classList.remove("yellowBorder");
      }
      this.selectedImage = this.images[index];
      this.selectedImageEl = event.target.closest("li");
      this.selectedImageEl.classList.add("yellowBorder");

      if (this.selectedDesc !== null) {
        this.checkMatch();
      }
    },
    selectDescription(item, event) {
      if (this.selectedDescEl) {
        this.selectedDescEl.classList.remove("yellowBorder");
      }
      this.selectedDesc = item;
      this.selectedDescEl = event.currentTarget;
      this.selectedDescEl.classList.add("yellowBorder");

      if (this.selectedImage !== null) {
        this.checkMatch();
      }
    },
    checkMatch() {
      const imageEl = this.selectedImageEl;
      const descEl = this.selectedDescEl;

      if (this.selectedImage.index === this.selectedDesc.index) {
        var audio = new Audio(this.correctAnswerSound);
        audio.play();
        this.$parent.errorNumber++;
        this.$parent.showCorrectAnswerIcon = true;
        setTimeout(() => { this.$parent.showCorrectAnswerIcon = false; }, 1000);
        localStorage.setItem("errorNumber", this.$parent.errorNumber);

        imageEl.classList.remove("yellowBorder");
        imageEl.classList.add("greenBorder");
        descEl.classList.remove("yellowBorder");
        descEl.classList.add("greenBorder");

        var countGreenBorder = document.getElementsByClassName("greenBorder").length;
        if (countGreenBorder / 2 >= this.descriptions.length) {
          setTimeout(() => {
            this.completed = true;
            setTimeout(() => {
              this.$parent.showPointInformation = false;
              localStorage.setItem("showPointInformation", this.$parent.showPointInformation);
              this.$parent.showPickedItem = false;
              localStorage.setItem("showPickedItem", this.$parent.showPickedItem);
              this.$parent.showMainScreen = true;
              localStorage.setItem("showMainScreen", this.$parent.showMainScreen);
              this.$parent.nextPointNumber();
              this.$parent.showMainScreen = true;
            }, 2000);
          }, 200);
        }
      } else {
        this.$parent.errorNumber--;
        localStorage.setItem("errorNumber", this.$parent.errorNumber);

        imageEl.classList.remove("yellowBorder");
        imageEl.classList.add("redBorder");
        descEl.classList.remove("yellowBorder");
        descEl.classList.add("redBorder");
        this.$parent.showWongAnswerIcon = true;
        new Audio(this.wrongAnswerSound).play();

        setTimeout(() => {
          imageEl.classList.remove("redBorder");
          descEl.classList.remove("redBorder");
          this.$parent.showWongAnswerIcon = false;
        }, 1000);
      }

      this.selectedImage = null;
      this.selectedImageEl = null;
      this.selectedDesc = null;
      this.selectedDescEl = null;
    },
    shuffleArray(array) {
      // Shuffle array using Fisher-Yates algorithm
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    translate(lang) {
      switch (lang) {
        case "ar":
          this.translation = {
            chooseImageThenDefinition: "عليكم مطابقة الصورة مع الكلمة المناسبة.",
            bravo: "!أحسنتم",
          };
          break;
        case "en":
          this.translation = {
            chooseImageThenDefinition: "Match each image with the right word.",
            bravo: "Well done!",
          };
          break;
        case "he":
          this.translation = {
            chooseImageThenDefinition: "עליכם להתאים בין תמונה למילה המתאימה לה.",
            bravo: "!כל הכבוד",
          };
          break;
        default:
          this.translation = {
            chooseImageThenDefinition: "Associez chaque image au bon mot.",
            bravo: "Bravo !",
          };
      }
    },
  },
};
</script>

<style scoped>
/* ROOT */
.match-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 10px 80px;
  font-family: "VarelaRound", sans-serif;
}

/* INSTRUCTION CHIP */
.instruction-chip {
  display: inline-block;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  padding: 10px 22px;
  font-family: "VarelaRound", sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: white;
  text-align: center;
  margin-bottom: 20px;
}

/* TWO-COLUMN GRID */
.match-grid {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 640px;
  margin-bottom: 100px;
}

/* IMAGE COLUMN */
.image-list {
  width: 48%;
}

.image-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.image-list li {
  display: block;
  cursor: pointer;
  overflow: hidden;
  border: 4px solid rgba(255, 255, 255, 0.8);
  border-radius: 14px;
  transition: border-color 150ms ease, transform 100ms ease;
  background: rgba(0, 0, 0, 0.3);
}

.image-list li:active {
  transform: scale(0.97);
}

.image-list li img {
  width: 100%;
  height: 130px;
  object-fit: cover;
  display: block;
}

/* DESCRIPTION COLUMN */
.description-list {
  width: 48%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.descriptionItem {
  height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px 8px;
  background: #0070b075;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  font-family: "VarelaRound", sans-serif;
  font-size: 17px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  transition: border-color 150ms ease, transform 100ms ease;
}

.descriptionItem:active {
  transform: scale(0.97);
}

/* JS-MANAGED BORDER CLASSES */
.yellowBorder {
  border: 4px solid #ffe600 !important;
  box-shadow: 0 0 10px rgba(255, 230, 0, 0.55);
}

.greenBorder {
  border: 4px solid #4cff4c !important;
  box-shadow: 0 0 10px rgba(76, 255, 76, 0.5);
}

.redBorder {
  border: 4px solid #ff3d3d !important;
  box-shadow: 0 0 10px rgba(255, 61, 61, 0.5);
}

/* COMPLETION OVERLAY */
.over {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.result-overlay {
  animation: overlayFadeIn 0.35s ease;
}

@keyframes overlayFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.result-card {
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 28px;
  padding: 48px 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  animation: cardPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes cardPop {
  from {
    transform: scale(0.7);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.result-icon {
  font-size: 64px;
  line-height: 1;
}

.result-title {
  font-family: "VarelaRound", sans-serif;
  font-size: 32px;
  font-weight: bold;
  color: white;
  letter-spacing: 1px;
}
</style>
